<template>
  <div id="ppersonCenter" :class="(threadList.length==0 || activityList.length==0)?'theight':''">
    <!-- <Header2></Header2> -->
    <div class="ScenterBox">
      <div class="listBox inner">
        <div class="topSearch ">
          <div class="logoBox">
            <div class="logo"></div>
            <!-- <img class="logo" src="@/assets/imgs/logo.png" alt=""> -->
          </div>
          <div class="searchBox">
            <input type="text" v-model="val" class="ipt" @keyup="getSearchList($event)">
            <a href="javascript:;" class="searchBtn" @click="getSearchList('')">搜索</a>

          </div>
        </div>
        <div class="innerList">
          <div class="goback"><a href="javascript:;" @click="goHome">返回首页</a></div>
          <div class="tab">
            <span :class="tabIndex==0?'active':''" @click="changeTab(0)">帖子</span>
            <span :class="tabIndex==1?'active':''" @click="changeTab(1)">活动</span>
          </div>
          <div class="tzLists" v-if="tabIndex==0">
            <div class="newsList">
              <ul>
                <li v-for="(item,i) in threadList" @click="intoDetail(item.tid)" :key="i">
                  <div class="clearfix">
                    <!-- 如果有图的话 没图默认纯文字-->
                    <div class="left_img" v-if="item.thumbs">
                      <img class="l_img" :src="item.thumbs[0]" alt="">
                    </div>
                    <div class="hasOne" :class="!item.thumbs?'hasOne2':''">
                      <h3>
                        <span class="txt">{{item.subject}}</span>
                      </h3>
                      <div class="btm_txt">
                        <!-- <span class="tag" v-if="item.tit">{{item.tit}}</span> -->
                        <!-- <img class="avatar" alt=""> -->
                        <a class="msg" href="javascript:;" v-if="item.dateline!=0">{{item.author}} · {{item.replies}}条评论
                          · {{happenTimeFun(item.dateline)}}</a>
                      </div>
                    </div>
                  </div>
                </li>
                <div v-if="threadList.length>0" class="tipsTxt">
                  <div v-if="!threadCompleted" class="tipsTxt">正在加载更多内容</div>
                  <div v-else class="tipsTxt">已加载全部</div>
                </div>
                <li v-else class="tipsTxt">暂无数据
                </li>
              </ul>
            </div>
          </div>
          <div class="activeLists" v-else>
            <div class="newsList">
              <ul>
                <li v-for="(item,i) in activityList" @click="intoDetail(item.tid)" :key="i">
                  <p class="ttitle nowrap">{{item.subject}}</p>
                  <div class="btm">
                    <div class="bleft">
                      <img class="limg" :src="item.thumbs[0]" alt="">
                    </div>
                    <div class="bcenter">
                      <!-- 价格取goods 和groupBuyGoods 里的最小价格 -->
                      <p>价格：<span class="money">{{item.price}}元起</span></p>
                      <p class="activityPlace">地点：{{item.place}}</p>
                      <p>时间：{{happenTimeFun(item.starttimefrom)}}至{{happenTimeFun(item.starttimeto)}}
                      </p>
                    </div>
                    <div class="bright clearfix">
                      <div class="allNumbox">
                        <div class="lookBtn">查看详情</div>
                        <div class="lbox">
                          <span class="lt">报名人数</span>
                          <span class="num">{{item.applynumber}}</span>
                        </div>
                        <div class="lbox lcenter">
                          <span class="lt">评论</span>
                          <span class="num">{{item.replies}}</span>
                        </div>
                      </div>
                      <div class="lbox shareBox">
                        <span class="lt share">扫码报名</span>
                        <span class="codeBox">
                          <img class="code" src="http://api.linyouquan.net/imgs/wap/share_erweima.png" alt="">
                        </span>
                        <div class="outerCode">
                          <div style="text-align:center;left: 25px;position: relative;" :id="codeid(i)"></div>
                          <p class="txt">微信扫一扫即可快速报名活动</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <div v-if="activityList.length>0" class="tipsTxt">
                  <div v-if="!activityCompleted" class="tipsTxt">正在加载更多内容</div>
                  <div v-else class="tipsTxt">已加载全部</div>
                </div>
                <div v-else class="tipsTxt">暂无数据
                </div>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import service from '@/api/service/service'
  import {
    storageData
  } from '@/assets/js/storage'
  import Header2 from '../common/header2'
  import Rightbox from '../common/loginBox'

  import QRCode from "qrcodejs2"; //生成二维码
import Axios from 'axios'
  export default {
    components: {
      Header2,
      Rightbox
    },
    data() {
      return {
        tabIndex: 0,
        imgSrc: '',
        val: this.$route.query.keywords,
        threadList: [],
        activityList: [],
        page: 1,
        tid: '',
        threadListPage: 1,
        activityListPage: 1,
        loading: false,
        //  用于判断帖子列表是否已经加载完全部数据
        threadCompleted: false,
        //  用于判断活动列表是否已经加载完全部数据
        activityCompleted: false,
        scrolling: false,
      }
    },
    created() {
      this.tabIndex = this.$route.query.curtab - 1
    },
    mounted() {
      document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')//设置此页背景色
      this.getthreadList()
      if (this.tabIndex == 1) {
        this.getactivityList()
      }
      window.addEventListener('scroll', () => {
        const SEARCH_HEIGHT = 37
        const TAB_HEIGHT = 65
        let scrollTop =  document.documentElement.scrollTop ||  window.pageYOffset || document.body.scrollTop
        let clientHeight = document.documentElement.clientHeight ? document.documentElement.clientHeight+2 : document.body.clientHeight+2
        let scrollHeight = document.documentElement.scrollHeight ? document.documentElement.scrollHeight : document.body.scrollHeight
        if (scrollTop + clientHeight + SEARCH_HEIGHT +
          TAB_HEIGHT >= scrollHeight) {
          if (this.scrolling) return
          this.scrolling = true
          if (this.tabIndex === 0) {
            this.loadMoreThread()
          } else {
            this.loadMoreActi()
          }
          const timer = setTimeout(() => {
            this.scrolling = false
            clearTimeout(timer)
          }, 300)

        }
      })
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('scroll', () => {}) 
      })

    },
    methods: {
      codeid(i) {
        return "qrcode" + i
      },
      //生成二维码
      QRCodeMsg(url, i) {
        var qrcode = new QRCode(`qrcode${i}`, {
          text: url, //this.link, // 需要转换为二维码的内容
          width: 100,
          height: 100
        })
      },
      //帖子详情
      intoDetail(tid) {
        let routerData = this.$router.resolve({path:`/newsdetail/${tid}`})
        window.open(routerData.href,'_blank');
      },
      // intoDetail(tid, url) {
      //   // let routeData = this.$router.resolve({
      //   //   path: `/newsdetail/${tid}`,
      //   // });
      //   if (!tid) {
      //     window.open(url, '_blank');
      //   } else {
      //     window.open(`routeData.href?site_id=${this.$route.query.sid}`, '_blank');
      //   }
      // },
      happenTimeFun(num) { //时间戳数据处理
        let date = new Date(parseInt(num) * 1000);
        //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM; //月补0
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d; //天补0
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h; //小时补0
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m; //分钟补0
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s; //秒补0
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m;

      },
      changeTab(tabIndex) {
        //  切换时, 当没数据时才重新调用接口
        this.tabIndex = tabIndex
        if (tabIndex === 0) {
          this.threadListPage = 1
          this.threadList = []
          this.threadCompleted = false
          this.getthreadList()
        } else {
          this.activityListPage = 1
          this.activityList = []
          this.activityCompleted = false
          this.getactivityList()
        }
      },
      intoPerson() {
        this.$router.push({
          path: `/pcenter?sid=${this.$route.query.sid}`
        })
      },

      getthreadList() {
        //  默认每页加载20条数据
        // const PAGE_SIZE = 20
        this.loading = true
        service.post(
            `${this.commonIp}/v1/search/thread`,{
              keywords:this.val,
              page:this.threadListPage
            }
          )
          .then((res) => {
            // console.log(res)
            const {code,data} = res.data
            const {list,hasMore} = data
            if (code == 200) {
              this.threadList = [...this.threadList, ...list]
              //  判断帖子列表是否已经加载完全部(当后台返回的列表小于20条, 也就是小于PAGE_SIZE时, 说明已经全部加载完毕)
              this.threadCompleted = hasMore === 0
            }
          })
          .catch((err) => {
            console.log(err)
          })
          .finally(() => {
            this.loading = false
          })
      },

      getactivityList() {
        //  默认每页加载20条数据
        // const PAGE_SIZE = 20
        this.loading = true
        let _self = this
        //改成调活动季接口
        service.get(`${this.commonIp}/v1/threads/activityList?page=${this.activityListPage}&keywords=${this.val}`)
        .then((res) => {
          // console.log(res)
          let {skip,expire,threadlist,hasMore} = res.data.data
          if(res.data.code ==200){
              this.activityList = [...this.activityList, ...threadlist]
              this.activityCompleted = hasMore === 0
              this.$nextTick(() => {
                this.activityList.forEach((item, i) => {
                  //生成这个码时，text传的是url和当前用户的id，然后扫这个码的时候进入触屏版详情页
                  if (storageData.getUserInfo()) {
                    item.imgSrc = _self.QRCodeMsg(
                      `https:${this.commonIp}/v1/threads/${item.tid}?shareUser=${storageData.getUserInfo().openId}`,
                      i)
                  } else {
                    item.imgSrc = _self.QRCodeMsg(`https:${this.commonIp}/v1/threads/${item.tid}`, i)
                  }
                })
              })
          }
        })
        .catch((err) => {
            console.log(err)
        })
        .finally(() => {
            this.loading = false
        })  
      },
      loadMoreThread() { 
        if(this.loading || this.threadCompleted) return
        this.threadListPage+=1
        this.getthreadList()
      },
      loadMoreActi() { 
        if (this.loading || this.activityCompleted) return
        this.activityListPage += 1
        this.getactivityList()
      },
      goHome() {
        this.$router.push('/')
      },
      
      getSearchList(e) { //展示搜索列表
        if (e && e.keyCode != '13') {
          return
        } else {
          if (this.tabIndex == 0) {
            this.threadListPage = 1
            this.threadList = []
            this.threadCompleted = false
            this.getthreadList()
          } else {
            this.activityListPage = 1
            this.activityList = []
            this.activityCompleted = false
            // this.loading = true
            this.getactivityList()
          }
        }
      },

      // **获取最小价格
      // GetMinPrice({
      //   options = {}
      // }) {
      //   const {
      //     goods = [], groupBuyGoods = []
      //   } = options
      //   const optionsType = Object.prototype.toString.call(options).slice(8, -1).toUpperCase()
      //   if (optionsType === 'OBJECT') {
      //     /*@*/ //有价格的数据集合
      //     let priceList = []
      //     if (goods && Array.isArray(goods)) {
      //       priceList = priceList.concat(goods)
      //     }
      //     if (groupBuyGoods && Array.isArray(groupBuyGoods)) {
      //       priceList = priceList.concat(groupBuyGoods)
      //     }
      //     //  //从价格的数据中提出价格的数组，然后做从小到大的排序
      //     const priceNumList = priceList.reduce((acc, item) => {
      //       acc.push(item.price)
      //       return acc
      //     }, []).sort((a, b) => a - b)
      //     return priceNumList.length > 0 ? priceNumList[0] : '0'
      //   } else {
      //     return '0'
      //   }
      // }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @import '~@/assets/less/index.less';
  #app {
    overflow: hidden;
  }
  #ppersonCenter {
    background: #f2f2f2;
    overflow: hidden;
    &.theight {
      // height: 100vh;
    }
    .ScenterBox {
      overflow: hidden;
      .topSearch {
        background: none;
        margin-top: 20px;
        .logoBox {
          .fl();
          margin: 0 20px 0 0;

          .logo {
            width: 96px;
            height: 32px;
          }
        }
        .searchBox {
          .fl();
          height: 37px;
          .ipt {
            width: 600px;
            height: 100%;
            box-sizing: border-box;
            border: 0;
            padding: 0 8px 0;
            border: 1px solid #ea5d3c;
            border-radius: 5px 0 0 5px;
            .fl();

            &:focus {
              outline: none;
            }
          }

          .searchBtn {
            .fl();
            width: 90px;
            display: inline-block;
            background: #ea5d3c;
            height: 100%;
            line-height: 36px;
            color: #fff;
            text-align: center;
            outline: none;
            border-radius: 0 5px 5px 0;
          }
        }
      }

      .listBox {
        width: 1100px;
        background-color: #f2f2f2;
        margin:0 auto;
        overflow: hidden;
        .innerList {
          position: relative;
          width: 690px;
          margin-left: 116px;
          .fl();
          .goback{ position: absolute;right: 0;line-height: 65px;
           a{
             color: #d51938;
           }
          }
          .tab {
            height: 65px;
            line-height: 65px;

            span {
              font-size: @ft20;
              margin: 0 30px 0 0;
              cursor: pointer;

              &.active {
                color: #ea5d3c;
              }
            }
          }

          .tzLists {
            .newsList {
              .tipsTxt{
            color: #999;
            text-align: center;
          }
              li{
                border-bottom: 1px solid #f2f2f2;
              }
              background: #fff;
              padding: 20px;
              box-sizing: border-box;
            }

            .hasOne {
              width: 100%;
            }

            li {
              &:first-child {
                padding-top: 0;
              }

              .left_img {
                margin-right: 20px;

                img {
                  width: 100%;
                }
              }
            }
          }

          .activeLists {
            .newsList {
              padding: 20px;
              background: #fff;
              .tipsTxt{
            color: #999;
            text-align: center;
          }
              li {
                border-bottom: 1px solid #f2f2f2;
                &:first-child {
                  padding-top: 0;
                }

                .ttitle {
                  font-size: @ft20;
                  margin: 0 0 10px 0;
                  cursor: pointer;
                }

                .btm {
                  display: flex;
                  .bleft {
                    flex: 0 0 100px;
                    width: 100px;
                    height: 75px;
                    border-radius: 9px;
                    overflow: hidden;

                    img {
                      width: 100px;
                      height: 75px;
                      object-fit: cover;
                    }
                  }

                  .bcenter {
                    cursor: pointer;
                    flex: 1.6;
                    margin: 0 20px;
                    .activityPlace{
                        overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;line-clamp: 2;-webkit-box-orient: vertical;line-height: 24px;
                    }
                    p {
                      font-size: @ft14;
                      line-height: 24px;
                      
                      .money {
                        color: #ff871d;
                      }
                    }
                  }

                  .bright {
                    flex: 1;
                    margin-top: 12px;
                    cursor: pointer;

                    .allNumbox {
                      .fl();
                      position: relative;
                      height: 55px;

                      &:hover {
                        .lookBtn {
                          display: block;
                          background: #f9cc64;
                          box-shadow: 0px 20px 24px #ffb44c inset;
                        }
                      }

                      .lookBtn {
                        display: none;
                        position: absolute;
                        width: 115px;
                        height: 55px;
                        line-height: 55px;
                        border-radius: 9px;
                        background: #FFA52A;
                        color: #fff;
                        font-size: @ft24;
                        text-align: center;
                        box-shadow: 0px 20px 24px #ffbb74 inset;
                      }
                    }

                    .lbox {
                      .fl();
                      width: 55px;
                      height: 55px;
                      border: 1px solid #e7e7e7;
                      border-radius: 9px;

                      &.shareBox {
                        position: relative;
                        border-color: #72c8bb;

                        &:hover {
                          .outerCode {
                            display: block;
                          }
                        }
                        .outerCode {
                          position: relative;
                          width: 178px;
                          height: 190px;
                          background: #fff;
                          text-align: center;
                          display: none;
                          padding: 9px;
                          box-sizing: border-box;
                          border: 1px solid #eee;
                          left: 46px;
                          bottom: 136px;
                          padding-top: 30px;

                          img {
                            display: block;
                            width: 124px;
                            height: 124px;
                            margin: 0 auto;
                            text-align:center;
                            left:0;
                            right: 0;
                          }

                          .txt {
                            color: #666;
                            font-size: @ft12;
                            text-align:center;
                            margin-top: 10px;
                          }
                        }
                      }

                      &.lcenter {
                        margin: 0 5px;
                      }

                      .lt {
                        text-align: center;
                        width: 100%;
                        font-size: 10px;
                        color: #454545;
                        display: inline-block;
                        padding-bottom: 2px;
                        border-bottom: 1px dashed #e7e7e7;

                        &.share {
                          height: 24px;
                          line-height: 24px;
                          background: #72c8bb;
                          color: #fff;
                          position: absolute;
                          top: -1px;
                          border-radius: 9px 9px 0 0;
                        }
                      }

                      .num {
                        font-size: @ft14;
                        width: 100%;
                        text-align: center;
                        margin-top: 7px;
                        display: inline-block;
                      }

                      .codeBox {
                        width: 100%;
                        display: inline-block;
                        position: absolute;
                        top: 28px;
                        text-align: center;

                        .code {
                          width: 20px;
                          height: 20px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .innerRight {
          .fr();
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/search/search.vue